import { connect } from "react-redux";
import { VinLookup as Component, VinLookupProps } from "./VinLookup.component";
import {
  changeLookupTypeMethod,
  resetSearchResults,
  setVin,
  searchByVIN
} from "../../action";
import { getVehicleLookupSearchResults } from "../../selector";
import { RootState } from "../../reducers";


const mapStateToProps = (state: RootState) => ({
  partnerCode: state.partnerDetails.partnerDetails?.partnerCode,
  searchResults: getVehicleLookupSearchResults(state)
});

export const VinLookup = connect(mapStateToProps, {
  changeLookupTypeMethod,
  searchByVIN,
  setVin,
  resetSearchResults
} as Pick<VinLookupProps, "changeLookupTypeMethod" | "searchByVIN" | "setVin" | "resetSearchResults">)(Component);
